import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import { TitleBar } from '../common/theme';
import { toArray, timeConverter } from '../../Utils';

const SubscriptionTableComp = ({pageState}) => {
    const [programOwnedData, setProgramOwnedData] = useState([]);
    const [customerData, setCustomerData] = useState({numClasses:'-', numStudents:'-'});

    useEffect(() => {
        if(pageState && pageState.ownedPrograms && pageState.ownedPrograms.data && programOwnedData.length === 0){
            setProgramOwnedData(toArray(pageState.ownedPrograms.data).map(progRec=>{ 
                progRec.title = (pageState.programs[progRec.NAME]) ? pageState.programs[progRec.NAME].title: progRec.NAME; 
                return progRec;
            }));
        }

        if(pageState && pageState.customer && pageState.customer.data && customerData.numClasses === '-'){
            setCustomerData({numClasses:pageState.customer.data.NumClasses, numStudents:pageState.customer.data.NumStudents});
        }

    });   

    const titleRow = <Row style={{fontWeight:'bold'}}>
        <Col style={{textAlign: 'left'}} xs='6'>Program Name</Col>
        <Col style={{textAlign: 'left'}} xs='3'>Renew Date</Col>
        <Col style={{textAlign: 'left'}} xs='3'>License</Col>
    </Row>;

    return (<>
        <Container>

            <TitleBar>
                <Col  style={{textAlign: 'left', color: 'white' }} xs='4'><h3>Subscriptions</h3></Col>
                <Col  style={{textAlign: 'left', color: 'white' }} xs='8'>
                <span className={'pull-right'}>
                    <h3>Classes({customerData.numClasses}) Students({customerData.numStudents})</h3>
                </span>    
                </Col>
            </TitleBar>
            </Container>            
            <div style={{overflowY:'scroll', overflowX : 'hidden',height:'300px', padding:'10px', borderBottom: '1px solid #cfcfcf', borderLeft: '1px solid #cfcfcf', borderRight: '1px solid #cfcfcf'}}>
                {titleRow}
                {programOwnedData.map((classRec, i) => 
                    (classRec.NAME) && <ProgramRow key={i} data={classRec} />
                )}
            </div>        
        </>
    );
};

SubscriptionTableComp.propTypes = {
    data: PropTypes.array
};

const ProgramRow = (params) => {
    let {NAME, title, START_DATE, License} = params.data;
    START_DATE = parseInt(START_DATE) + (1000*60*60*24*365);
    return (
        <>
            <Row style={{ margin: '2px'}}>
                <Col style={{textAlign: 'left'}} xs='6'> <a target="_blank" href={`https://trial.essentialskills.com/scope/${NAME.toUpperCase()}.pdf`} rel="noopener noreferrer"> {title==='Complete Basic Skills'?'Essential Skills Complete':title} </a></Col>
                <Col style={{textAlign: 'left'}} xs='3'> {timeConverter(START_DATE)} </Col>
                <Col style={{textAlign: 'left'}} xs='3'> {License} </Col>
            </Row>
        </>
    );
};

export default SubscriptionTableComp;